<div class="app flex-row">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-6">
				<iframe #test [src]='homerUrl' width="600" height="560" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
			</div>
		</div>
		<div class="row justify-content-center mt-5">
			<div class="col-md-6">
				<h3 class="text-muted" [ro-i18n] eikey="errors.forOforMsg">The page you are looking for was not found.</h3>
			</div>
		</div>
		<div class="row justify-content-center">
			<div class="col-md-6">
				<a [routerLink]="['/dashboard']" [ro-i18n] eikey="errors.backHome">New Email</a>
			</div>
		</div>

	</div>
</div>
